<template>
    <p>{{ element.text }}</p>
</template>

<script>
    export default {
        name: "TextElementPreview",
        props: {
            element: {
                type: Object
            }
        }
    }
</script>

<style scoped>

</style>